import React from 'react';
import { IonToggle } from '@ionic/react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useOrg } from '../hooks/useOrg';
import { useTheme } from '../theme/useTheme';
import { ar_logoutUser } from '../../../Redux/Actions/AuthActions';
import type { Org } from '../api/types';
import './su-components.css';

const ORG_BOXES: Org[] = ['SU', 'ETH'];

/** Compact sheet above the bottom bar (replaces the full More page). `layerRef` lets the parent size the layer to the bar. */
const MoreSheet: React.FC<{ onClose: () => void; layerRef?: React.Ref<HTMLDivElement> }> = ({ onClose, layerRef }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((s: any) => s.authReducer);
  const rawOrg = ((auth?.user?.org || 'ALL') as string).toString().trim().toUpperCase();
  const canAccessSU = rawOrg === 'SU' || rawOrg === 'ALL';
  const canAccessETH = rawOrg === 'ETH' || rawOrg === 'ALL';
  const { isDark, setTheme } = useTheme();
  const { org, canSwitch, setOrg } = useOrg();
  const name: string = auth?.user?.username || 'User';

  const go = (path: string) => {
    onClose();
    history.push(path);
  };

  return (
    <div className="su-more-layer" ref={layerRef}>
      <div className="su-more-backdrop" data-testid="su-more-backdrop" onClick={onClose} />
      <div className="su-more-sheet" role="dialog" aria-label="More">
        <div className="su-more-user">
          <span className="su-avatar" aria-hidden="true">{name.trim().charAt(0).toUpperCase()}</span>
          <span className="su-more-name">{name}</span>
        </div>
        <div className="su-more-row">
          <label htmlFor="su-dark-toggle">Appearance</label>
          <span className="su-more-toggle">
            <span className="su-muted">Dark mode</span>
            <IonToggle
              id="su-dark-toggle"
              data-testid="su-dark-toggle"
              aria-label="Dark mode"
              checked={isDark}
              onIonChange={(e) => setTheme(e.detail.checked ? 'dark' : 'light')}
            />
          </span>
        </div>
        {canAccessSU && (
          <button type="button" className="su-more-row action" onClick={() => go('/legacy/sales/styleunion')}>
            Legacy Style Union view
          </button>
        )}
        {canAccessETH && (
          <button type="button" className="su-more-row action" onClick={() => go('/legacy/sales/eth')}>
            Legacy Ethnicity view
          </button>
        )}
        <button type="button" className="su-more-row action danger" onClick={() => dispatch(ar_logoutUser())}>
          Logout
        </button>
        {canSwitch && (
          <div className="su-orgboxes" role="radiogroup" aria-label="Organization">
            {ORG_BOXES.map((o) => (
              <button
                key={o}
                type="button"
                role="radio"
                aria-checked={o === org}
                className={`su-orgbox${o === org ? ' active' : ''}`}
                onClick={() => {
                  setOrg(o);
                  onClose();
                }}
              >
                {o}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreSheet;
